import NavBar from "./NavBar";
import Services from "../comps/Services";
import Footer from "./Footer";


export default function OurServices() {
    return (
        <>
            <NavBar />
            <Services />
            <Footer />
        </>
    )
}